import { useEffect } from 'react';
import UserAuthContainer from '../Containers/UserAuthContainer'
import useNavigation from '../Utils/navigationUtils'
import ROUTES from '../../routesConfig'

const LogoutPage = () => {

  const { navigateToPathWithReplace } = useNavigation()
  const { clearUserAndToken } = UserAuthContainer.useContainer()

  useEffect(() => {

    // Perform any other logout logic, like cleaning up user state if needed
    clearUserAndToken()

    // Redirect to public Apps listing as the unauthenticated home experience
    navigateToPathWithReplace(ROUTES.APPS)
  }, [clearUserAndToken, navigateToPathWithReplace])

  return null // Render nothing
}

export default LogoutPage
